import React, { useEffect, useState } from "react";
import axios from "axios";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { LuFileEdit } from "react-icons/lu";
import { FaRegTrashCan } from "react-icons/fa6";
import { ImCross } from "react-icons/im";
import Pagination from "../../utils/Pagination";
import "./Year.scss";
import { RiSortAlphabetAsc, RiSortAlphabetDesc } from "react-icons/ri";
import { createYear, deleteYear, fetchYearById, fetchYears, updateYear } from "../../services/api";
import AlertMsg from "../../components/AlertMsg/AlertMsg";
import Loading from "../../components/Loading/Loading";

const Year = () => {
  const [years, setYears] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
  const handleSort = () => {
    const sortedYears = [...years].sort((a, b) => {
      if (sortOrder === "asc") {
        return a.name.localeCompare(b.name);
      } else {
        return b.name.localeCompare(a.name);
      }
    });
    setYears(sortedYears);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc"); // Toggle sort order
  };
  const [formData, setFormData] = useState({
    name: "",
    activeStatus: true,
  });
  const [errors, setErrors] = useState({
    name: "",
    activeStatus: "",
  });
  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
 // Validation function
 const validateForm = () => {
  let formErrors = { name: "", activeStatus: "" };
  let valid = true;

  if (formData.name.trim() === "") {
    formErrors.name = "Block name is required";
    valid = false;
  }

  if (formData.activeStatus === null || formData.activeStatus === undefined) {
    formErrors.activeStatus = "Please select a status";
    valid = false;
  }

  setErrors(formErrors);
  return valid;
};

  const [viewYearDetails, setViewYearDetails] = useState(null);
  const [yearToDelete, setYearToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const yearsPerPage = 10;

  const fetchYear = async () => {
    setLoading(true);
    try {
      const response = await fetchYears();
      setYears(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching year data:", error);
    }finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchYear();
  }, []);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);

    // Reset form data and errors when closing the modal
    if (isModalOpen) {
      setFormData({
        id: 0,
        name: "",
        activeStatus: true,
      });
      setErrors({
        name: "",
        activeStatus: "",
      });
    }
  };

  const toggleViewModal = () => {
    setIsViewModalOpen(!isViewModalOpen);
    setViewYearDetails(null);
  };

  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);

    // Reset form data and errors when closing the modal
    if (isEditModalOpen) {
      setFormData({
        id: 0,
        name: "",
        activeStatus: true,
      });
      setErrors({
        name: "",
        activeStatus: "",
      });
      fetchYear();
    }
  };
  const toggleDeleteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setYearToDelete(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "activeStatus" ? value === "true" : value; 
    setFormData({
      ...formData,
      [name]: newValue,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const filteredYears = years.filter(
    (yearpage) =>
      yearpage.name &&
      yearpage.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const pageCount = Math.ceil(filteredYears.length / yearsPerPage);

  const getCurrentPageYears = () => {
    const startIndex = currentPage * yearsPerPage;
    const endIndex = startIndex + yearsPerPage;
    return filteredYears.slice(startIndex, endIndex);
  };
  const handleCancel = () => {
    setFormData({
      id: 0,
      name: "",
      activeStatus: true,
    });
    setIsEditModalOpen(false);
    setIsModalOpen(false);
    setIsDeleteModalOpen(false);
    setYearToDelete(null);
    setErrors({
      name: "",
      activeStatus: "",
    });
  };

  const handleAddYear = async () => {
    const isValid = validateForm();
    if (!isValid) return;
    setIsModalOpen(false);
    setLoading(true);
    try {
      const response = await createYear(formData);
      console.log("Added year:", response.data);
      setAlert({ visible: true, message: 'Year added successfully!', type: 'success' });
      handleCancel();
      fetchYear();

    } catch (error) {
      console.error("Error adding year:", error);
      setAlert({ visible: true, message: 'Error adding year. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };


 

  const handleEditYear = async (id) => {
    console.log(formData);
    try {
      const response = await fetchYearById(id); 
      setFormData(response.data);
      setIsEditModalOpen(true);
    } catch (error) {
      console.error("Error fetching year details:", error);
    }
  };


  const handleSaveEditYear = async () => {
    if (!validateForm()) {
      return;
    }
    setIsEditModalOpen(false);
    setLoading(true);
    try {
      const response = await updateYear(formData.id, formData);
      console.log("Updated year:", response.data);
      setAlert({ visible: true, message: 'Year updated successfully!', type: 'success' });
      handleCancel();
      fetchYear();
    } catch (error) {
      console.error("Error updating year:", error);
      setAlert({ visible: true, message: 'Error adding year. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteYear = async () => {
    if (!yearToDelete) return;
    setIsDeleteModalOpen(false);
    setLoading(true);
    try {
      await deleteYear(yearToDelete.id);
      handleCancel();
      setAlert({ visible: true, message: 'Year deleted successfully!', type: 'success' });
      fetchYear();
    } catch (error) {
      console.error("Error deleting year:", error);
      setAlert({ visible: true, message: 'Error deleting year. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteIconClick = (year) => {
    setYearToDelete(year);
    setIsDeleteModalOpen(true);
  };

  return (
    <div className="houseState">
      {loading && <Loading />}
      {!loading && (
      <div className="houseState-container box-shadow">
      {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}
        <div className="container-head p-15">
          <h2>Year</h2>
          <div className="btns">
            <span className="add-btn" onClick={toggleModal}>
              <IoIosAddCircleOutline />
              <p>Add Year</p>
            </span>
          </div>
        </div>
        <div className="table-filters">
          <div className="search-filter">
            <label htmlFor="searchYear">
              <FaSearch />
            </label>
            <input
              type="text"
              id="searchYear"
              placeholder="Search by Year"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        </div>
        <div className="houseState-content" style={{ overflowX: "auto" }}>
          <div className="table-container">
            <table className="custom-table">
              <thead>
                <tr>
                <th onClick={handleSort} style={{ cursor: 'pointer' }}>
                      Year {sortOrder === "asc" ? <RiSortAlphabetAsc /> : <RiSortAlphabetDesc />} {/* Sorting icon */}
                    </th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {getCurrentPageYears().length > 0 ? (
                  getCurrentPageYears().map((item) => (
                    <tr key={item.id}>
                      <td className="text-left">{item.name}</td>
                      <td className="text-center">
                        <p className={
                          item.activeStatus ? "active" : "inactive"
                        }>{item.activeStatus ? "Active" : "Inactive"}</p>
                      </td>
                      <td className="text-center">
                        <div className="action-btn">
                          {/* <span
                            className="btn view-btn"
                            onClick={() => handleViewYear(item.id)}
                          >
                            <GrView />
                          </span> */}
                          <span
                            className="btn edit-btn"
                            onClick={() => handleEditYear(item.id)}
                          >
                            <LuFileEdit />
                          </span>
                          <span
                            className="btn delete-btn"
                            onClick={() => handleDeleteIconClick(item)}
                          >
                            <FaRegTrashCan />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">No years found</td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination
            pageCount={pageCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
          </div>
         
        </div>
      </div>
      )}

      {/* Add Modal */}
      {isModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Add Year</h3>
              <span className="close-icon" onClick={toggleModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
            <div className={`add-form ${errors.name ? "error" : ""}`}>
                <label htmlFor="year">Year</label>
                <input
                  type="text"
                  name="name"
                  maxLength={50}
                  value={formData.name}
                  onChange={handleInputChange}
                  className={errors.name ? "input-error" : ""}
                />
               
              </div>
              <div className="btn-container">
                <div className="addforbtns">

                  <button className="btn-cancel" onClick={toggleModal}>
                    Cancel
                  </button>
                  <button className="btn" onClick={handleAddYear}>
                    Add Year
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* View Modal */}
      {isViewModalOpen && viewYearDetails && (
        <div className="screen">
          <div className="screen-container">
            <div className="view-head">
              <h3>Year Details</h3>
              <span className="close-icon" onClick={toggleViewModal}>
                <ImCross />
              </span>
            </div>
            <div className="view-details">
              <p>
                <strong>Year:</strong> {viewYearDetails.name}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                {viewYearDetails.activeStatus ? "Active" : "Inactive"}
              </p>
            </div>
            <button className="btn" onClick={toggleViewModal}>
              Close
            </button>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {isEditModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Edit Year</h3>
              <span className="close-icon" onClick={toggleEditModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
              <div className="add-form">
                <label htmlFor="year">Year</label>
                <input
                  type="text"
                  id="year"
                  name="name"
                  maxLength={50}
                  value={formData.name}
                  onChange={handleInputChange}
                  className={errors.name ? "input-error" : ""}
                />
              </div>
              <div className="add-form">
                <label htmlFor="activeStatus">
                  Active Status:
                </label>
                <div className=" custom-radio-group">
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={true}
                      checked={formData.activeStatus === true}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Active
                  </label>
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={false}
                      checked={formData.activeStatus === false}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Inactive
                  </label>
                  {errors.activeStatus && (
                    <span className="error-message">{errors.activeStatus}</span>
                  )}
                </div>
              </div>
              <div className="btn-container">
                <div className="addforbtns">
                  <button className="btn-cancel" onClick={toggleEditModal}>
                    Cancel
                  </button>
                  <button className="btn" onClick={handleSaveEditYear}>
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Delete Modal */}
      {isDeleteModalOpen && (
        <div className="screen">
          <div className="screen-container delete-popup">


            <h2>Are you sure you want to delete this year?</h2>
            <p>
              <strong>Year:</strong> {yearToDelete?.name}
            </p>

            <div className="btns">
              <button className="delete btn" onClick={handleDeleteYear}>
                Confirm Delete
              </button>
              <button className="btn-cancel" onClick={toggleDeleteModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Year;
